// hooks/useUserData.js
import { useEffect, useState } from "react";
import { fetchFromAirtable, fetchRecordsFields } from "../utils/airtable";

export const useUserData = (memberstack) => {
  const [userData, setUserData] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [data, setData] = useState(null);
  const [detectedDemarche, setDetectedDemarche] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const member = await memberstack.getCurrentMember();
      if (!member.data?.metaData?.airtable_id) return;

      const userRecord = await fetchFromAirtable("user", member.data.metaData.airtable_id);
      if (!userRecord) return;

      setUserData(userRecord);

      const fields = userRecord.fields;
      console.log("fields",fields)
      const demarches = ["transaction", "transaction_vendeur", "donation", "pma", "mariage","aucune_demarche","pacs"];
      const foundDemarche = demarches.find((d) => fields[d]);
      setDetectedDemarche(foundDemarche);
      

  
      if (!foundDemarche) return;
      //DÉMARCHE DÉTECTÉE
        const mainId = Array.isArray(fields[foundDemarche])
        ? fields[foundDemarche][0]
        : fields[foundDemarche];

      const transactionRecord = foundDemarche.includes("transaction")
        ? await fetchFromAirtable("transaction", mainId)
        : null;

      const demarcheData = foundDemarche === "pma" || foundDemarche === "mariage" || foundDemarche === "aucune_demarche" || foundDemarche === "pacs"
        ? await fetchFromAirtable(foundDemarche, mainId)
        : null;

      const relationField = foundDemarche === "pma" || foundDemarche === "mariage" || foundDemarche === "aucune_demarche" || foundDemarche === "pacs"
        ? foundDemarche
        : "transaction";

      const commonData = {
        evenement: await fetchRecordsFields("event", mainId, relationField),
        rdv: await fetchRecordsFields("rdv", mainId, relationField),
        action: await fetchRecordsFields("actions", mainId, relationField),
        document: await fetchRecordsFields("document", mainId, relationField),
      };

      if (foundDemarche.includes("transaction")) {
        const biens = await fetchRecordsFields("bien", mainId, "transaction");

        setData({
          user: fields,
          demarche: foundDemarche,
          transaction: transactionRecord?.fields || null,
          bien: biens,
          ...commonData,
          transactionId: transactionRecord?.id,
        });

        // Plusieurs transactions ?
        const allTransactions = await Promise.all(
          (fields[foundDemarche] || []).map(async (id) => {
            const res = await fetchFromAirtable("transaction", id);
            return res?.fields || null;
          })
        );
        setTransactions(allTransactions.filter(Boolean));
      } else {
        setData({
          user: fields,
          demarche: foundDemarche,
          [foundDemarche]: demarcheData?.fields || null,
          ...commonData,
        });
      }
      
    };

    fetchData();
  }, [memberstack]);

  return { data, userData, transactions, detectedDemarche, setData };
};